/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import StickyToolbar from "../../../partials/layout/StickyToolbar";
import ContractSidePanelAction from './ContractSidePanelAction';
import ContractSidePanelDrafts from './ContractSidePanelDrafts';
import Switch, { SwitchTypes } from 'devextreme-react/switch';
import * as preferencesDuck from '../../../store/ducks/preferences.duck';
import { injectIntl, FormattedMessage } from "react-intl";
import DropDownButton from 'devextreme-react/drop-down-button';
import { Badge } from "react-bootstrap";

class ContractSidePanel extends React.Component {
    constructor(props) {
        super(props);
        this.panelCloseBtnRef1 = React.createRef();
        this.panelCloseBtnRef2 = React.createRef();
        this.panelCloseBtnRef3 = React.createRef();

        this.state = {
            isPanel1Open: false,
            isPanel2Open: false,
            isPanel3Open: false
        };
    }
    renderListItem = (data, index) => {
        const { manualActions } = this.props;
        return (
            <div className="dx-list-items" role="listbox" aria-label="Items">
                <div className="dx-item" >
                    <div style={{ width: "100%", display: "flex" }} className="dx-item-content dx-list-item-content">
                        <div className="FlexContainerReverseRow">
                            <div style={{ width: "100%", flexGrow: 1, flexBasis: "25%" }}>
                                <Switch
                                    defaultValue={this.props.actionFilters.showRecurring}
                                    switchedOffText={this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" })}
                                    switchedOnText={this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" })}
                                    onValueChanged={(e) => { this.props.setPrefPendingActionFilter("showRecurring", e.value) }}
                                />
                            </div>
                            <div style={{ display: "flex", width: "100%", flexGrow: 3, textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", marginRight: 5 }}>
                                <ul style={{ padding: 0, display: "flex", alignItems: "center" }} className="kt-nav">
                                    <li className="kt-nav__item">
                                        <a href="#" onClick={(e) => e.preventDefault()} style={{ paddingLeft: 5, paddingRight: 7, cursor: "unset" }} className="kt-nav__link">
                                            <i className="kt-nav__link-icon flaticon2-refresh"></i>
                                        </a>
                                    </li>
                                </ul>
                                <span style={{ paddingRight: 5, fontWeight: 400, alignContent: "center" }}>
                                    <FormattedMessage id='PENDING_ACTION.FILTER.SHOW_RECURRING' />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dx-item" >
                    <div style={{ width: "100%", display: "flex" }} className="dx-item-content dx-list-item-content">
                        <div className="FlexContainerReverseRow">
                            <div style={{ width: "100%", flexGrow: 1, flexBasis: "25%" }}>
                                <Switch
                                    defaultValue={this.props.actionFilters.showOverdue}
                                    switchedOffText={this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" })}
                                    switchedOnText={this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" })}
                                    onValueChanged={(e) => { this.props.setPrefPendingActionFilter("showOverdue", e.value) }}
                                />
                            </div>
                            <div style={{ display: "flex", width: "100%", flexGrow: 3, textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", marginRight: 5 }}>
                                <div style={{ marginRight: 5 }} className="kt-notification__item-icon">
                                    <Badge variant="danger">{manualActions.RAGColor_1_Count}</Badge>
                                </div>
                                <span style={{ paddingRight: 5, fontWeight: 400, alignContent: "center" }}>
                                    <FormattedMessage id='PENDING_ACTION.FILTER.SHOW_OVERDUE' />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dx-item" >
                    <div style={{ width: "100%", display: "flex" }} className="dx-item-content dx-list-item-content">
                        <div className="FlexContainerReverseRow">
                            <div style={{ width: "100%", flexGrow: 1, flexBasis: "25%" }}>
                                <Switch
                                    defaultValue={this.props.actionFilters.show7Days}
                                    switchedOffText={this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" })}
                                    switchedOnText={this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" })}
                                    onValueChanged={(e) => { this.props.setPrefPendingActionFilter("show7Days", e.value) }}
                                />
                            </div>
                            <div style={{ display: "flex", width: "100%", flexGrow: 3, textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", marginRight: 5 }}>
                                <div style={{ marginRight: 5 }} className="kt-notification__item-icon">
                                    <Badge variant="warning">{manualActions.RAGColor_2_Count}</Badge>
                                </div>
                                <span style={{ paddingRight: 5, fontWeight: 400, alignContent: "center" }}>
                                    <FormattedMessage id='PENDING_ACTION.FILTER.SHOW_DUE_IN_7DAYS' />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dx-item" >
                    <div style={{ width: "100%", display: "flex" }} className="dx-item-content dx-list-item-content">
                        <div className="FlexContainerReverseRow">
                            <div style={{ width: "100%", flexGrow: 1, flexBasis: "25%" }}>
                                <Switch
                                    defaultValue={this.props.actionFilters.showUpcoming}
                                    switchedOffText={this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" })}
                                    switchedOnText={this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" })}
                                    onValueChanged={(e) => { this.props.setPrefPendingActionFilter("showUpcoming", e.value) }}
                                />
                            </div>
                            <div style={{ display: "flex", width: "100%", flexGrow: 3, textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", marginRight: 5 }}>
                                <div style={{ marginRight: 5 }} className="kt-notification__item-icon">
                                    <Badge variant="success">{manualActions.RAGColor_3_Count}</Badge>
                                </div>
                                <span style={{ paddingRight: 5, fontWeight: 400, alignContent: "center" }}>
                                    <FormattedMessage id='PENDING_ACTION.FILTER.SHOW_DUE_AFTER_7DAYS' />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    render() {
        const { showRecurring, showUpcoming, show7Days, showOverdue } = this.props.actionFilters;
        return (
            <>
                <StickyToolbar
                    onToggle={(panelNum, isOpen) => { panelNum === 1 ? this.setState({ isPanel1Open: isOpen }) : this.setState({ isPanel2Open: isOpen }); }}
                    panelCloseBtnRef1={this.panelCloseBtnRef1}
                    panelCloseBtnRef2={this.panelCloseBtnRef2}
                    panelCloseBtnRef3={this.panelCloseBtnRef3}
                    actionCount={this.props.filteredManualActions?.items?.length}
                    pendingDraftCount={this.props.pendingDrafts?.items?.length}
                    actionRAGColor={this.props.filteredManualActions?.RAGColor}
                />

                <div id="kt_quick_panel_2" className="kt-quick-panel" style={{ overflow: 'hidden' }}>
                    <a href="#" className="kt-quick-panel__close" id="kt_quick_panel_close_btn_2">
                        <i className="flaticon2-delete" />
                    </a>

                    <div className="kt-quick-panel__filter">
                        <DropDownButton

                            className={"PendingActions" + (!showRecurring || !showUpcoming || !show7Days || !showOverdue ? " FilterActive" : "")}
                            icon="filter"
                            showArrowIcon={false}
                            dropDownOptions={{ width: 300, maxHeight: '50vh' }}
                            dropDownContentRender={this.renderListItem}
                        />
                    </div>

                    <ContractSidePanelAction
                        isOpen={this.state.isPanel2Open}
                        contractid={this.props.contractid}
                        panelCloseBtnRef={this.panelCloseBtnRef2}
                    />
                </div>
                <div id="kt_quick_panel_3" className="kt-quick-panel" style={{ overflow: 'hidden' }}>
                    <a href="#" className="kt-quick-panel__close" id="kt_quick_panel_close_btn_3">
                        <i className="flaticon2-delete" />
                    </a>
                    <ContractSidePanelDrafts
                        isOpen={this.state.isPanel3Open}
                        contractid={this.props.contractid}
                        panelCloseBtnRef={this.panelCloseBtnRef3}
                    />
                </div>

            </>
        );
    }
}

const mapStateToProps = store => ({
    contractDashboard: store.contract.dashboard,
    contract: store.contract.contract,
    contractTemplate: store.contract.template,
    actionFilters: store.preferences.actionFilters,
    manualActions: store.contract.manualActions,
    filteredManualActions: store.contract.filteredManualActions,
    pendingDrafts: store.contract.pendingDrafts,
});
const mapDispatchToProps = {
    setPrefPendingActionFilter: preferencesDuck.actions.setPendingActionFilter,
}
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ContractSidePanel))
